import { vanillaCells, vanillaRenderers } from "@jsonforms/vanilla-renderers";
import BooleanCell, { booleanCellTester } from "./cells/BooleanCell";
import DateCell, { dateCellTester } from "./cells/DateCell";
import DateTimeCell, { dateTimeCellTester } from "./cells/DateTimeCell";
import EnumCell, { enumCellTester } from "./cells/EnumCell";
import IntegerCell, { integerCellTester } from "./cells/IntegerCell";
import NumberCell, { numberCellTester } from "./cells/NumberCell";
import NumberFormatCell, {
  numberFormatCellTester,
} from "./cells/NumberFormatCell";
import SliderCell, { sliderCellTester } from "./cells/SliderCell";
import TextAreaCell, { textAreaCellTester } from "./cells/TextAreaCell";
import TextCell, { textCellTester } from "./cells/TextCell";
import TimeCell, { timeCellTester } from "./cells/TimeCell";
import ArrayControlRenderer, {
  arrayControlTester,
} from "./complex/array/ArrayControlRenderer";
import TableArrayControl, {
  tableArrayControlTester,
} from "./complex/TableArrayControl";
import ActionSelectControl, {
  actionSelectTester,
} from "./controls/ActionSelectControl";
import {
  AsanaProjectControl,
  asanaProjectTester,
} from "./controls/AsanaProjectControl";
import { AsanaTeamControl, asanaTeamTester } from "./controls/AsanaTeamControl";
import { AsanaUserControl, asanaUserTester } from "./controls/AsanaUserControl";
import {
  AsanaWorkspaceControl,
  asanaWorkspaceTester,
} from "./controls/AsanaWorkspaceControl";
import {
  EmailRecipientsControl,
  emailRecipientsControlTester,
} from "./controls/EmailRecipientsControl";
import {
  GitHubRepoControl,
  GitHubRepoControlTester,
} from "./controls/GitHubRepoControl";
import {
  GoogleCalendarControl,
  GoogleCalendarControlTester,
} from "./controls/GoogleCalendarControl";
import {
  GoogleCalendarEventControl,
  GoogleCalendarEventControlTester,
} from "./controls/GoogleCalendarEventControl";
import { HiddenControl, hiddenControlTester } from "./controls/HiddenControl";
import {
  HtmlEmailPreviewControl,
  htmlEmailPreviewControlTester,
} from "./controls/HtmlEmailPreviewControl";
import {
  HubSpotCompanyControl,
  hubSpotCompanyTester,
  HubSpotContactControl,
  hubSpotContactTester,
  HubSpotDealControl,
  hubSpotDealTester,
} from "./controls/HubSpotObjectSearchControl";
import HubSpotOwnerControl, {
  hubSpotOwnerTester,
} from "./controls/HubSpotOwnerControl";
import HubSpotPipelineSearchControlWithProps, {
  hubSpotPipelineDealTester,
  hubSpotPipelineTicketTester,
} from "./controls/HubSpotPipelineSearchControl";
import HubSpotPipelineStageSearchControlWithProps, {
  hubSpotPipelineDealStageTester,
  hubSpotPipelineTicketStageTester,
} from "./controls/HubSpotPipelineStageSearchControl";
import InputControl, { inputControlTester } from "./controls/InputControl";
import {
  MarkdownEditorControl,
  markdownEditorTester,
} from "./controls/MarkdownEditorControl";
import OneOfRadioGroupControl, {
  oneOfRadioGroupControlTester,
} from "./controls/OneOfRadioGroupControl";
import RadioGroupControl, {
  radioGroupControlTester,
} from "./controls/RadioGroupControl";
import {
  SlackChannelControl,
  slackChannelTester,
} from "./controls/SlackChannelControl";
import {
  SlackFilesControl,
  slackFilesTester,
} from "./controls/SlackFilesControl";
import {
  slackMarkdownEditorTester,
  SlackMessageControl,
} from "./controls/SlackMessageControl";
import { SlackUserControl, slackUserTester } from "./controls/SlackUserControl";
import {
  ZoomRecordingControl,
  zoomRecordingTester,
} from "./controls/ZoomMeetingControl";
import GroupLayout, { groupTester } from "./layouts/GroupLayout";
import VerticalLayout, { verticalLayoutTester } from "./layouts/VerticalLayout";

export const renderers = [
  ...vanillaRenderers,
  { tester: verticalLayoutTester, renderer: VerticalLayout },
  { tester: groupTester, renderer: GroupLayout },
  { tester: actionSelectTester, renderer: ActionSelectControl },
  { tester: hiddenControlTester, renderer: HiddenControl },
  { tester: markdownEditorTester, renderer: MarkdownEditorControl },
  { tester: emailRecipientsControlTester, renderer: EmailRecipientsControl },
  { tester: htmlEmailPreviewControlTester, renderer: HtmlEmailPreviewControl },
  { tester: radioGroupControlTester, renderer: RadioGroupControl },
  { tester: oneOfRadioGroupControlTester, renderer: OneOfRadioGroupControl },
  { tester: inputControlTester, renderer: InputControl },
  { tester: groupTester, renderer: GroupLayout },
  { tester: asanaWorkspaceTester, renderer: AsanaWorkspaceControl },
  { tester: asanaTeamTester, renderer: AsanaTeamControl },
  { tester: asanaProjectTester, renderer: AsanaProjectControl },
  { tester: asanaUserTester, renderer: AsanaUserControl },
  { tester: hubSpotContactTester, renderer: HubSpotContactControl },
  { tester: hubSpotCompanyTester, renderer: HubSpotCompanyControl },
  { tester: hubSpotDealTester, renderer: HubSpotDealControl },
  { tester: hubSpotOwnerTester, renderer: HubSpotOwnerControl },
  { tester: slackUserTester, renderer: SlackUserControl },
  { tester: slackChannelTester, renderer: SlackChannelControl },
  { tester: slackMarkdownEditorTester, renderer: SlackMessageControl },
  { tester: slackFilesTester, renderer: SlackFilesControl },
  { tester: GitHubRepoControlTester, renderer: GitHubRepoControl },
  { tester: GoogleCalendarControlTester, renderer: GoogleCalendarControl },
  {
    tester: GoogleCalendarEventControlTester,
    renderer: GoogleCalendarEventControl,
  },
  { tester: tableArrayControlTester, renderer: TableArrayControl },
  { tester: arrayControlTester, renderer: ArrayControlRenderer },
  { tester: zoomRecordingTester, renderer: ZoomRecordingControl },
  {
    tester: hubSpotPipelineDealTester,
    renderer: HubSpotPipelineSearchControlWithProps,
  },
  {
    tester: hubSpotPipelineTicketTester,
    renderer: HubSpotPipelineSearchControlWithProps,
  },
  {
    tester: hubSpotPipelineDealStageTester,
    renderer: HubSpotPipelineStageSearchControlWithProps,
  },
  {
    tester: hubSpotPipelineTicketStageTester,
    renderer: HubSpotPipelineStageSearchControlWithProps,
  },
];

export const cells = [
  ...vanillaCells,
  { tester: textCellTester, cell: TextCell },
  { tester: dateCellTester, cell: DateCell },
  { tester: enumCellTester, cell: EnumCell },
  { tester: booleanCellTester, cell: BooleanCell },
  { tester: textAreaCellTester, cell: TextAreaCell },
  { tester: numberCellTester, cell: NumberCell },
  { tester: integerCellTester, cell: IntegerCell },
  { tester: sliderCellTester, cell: SliderCell },
  { tester: timeCellTester, cell: TimeCell },
  { tester: dateTimeCellTester, cell: DateTimeCell },
  { tester: numberFormatCellTester, cell: NumberFormatCell },
];
